const firebaseConfig = {
  apiKey: "AIzaSyCsIVQwM30okIm1RiklWb6OreOepMBxpdY",
  authDomain: "bd-simulab-authentication.firebaseapp.com",
  projectId: "bd-simulab-authentication",
  storageBucket: "bd-simulab-authentication.appspot.com",
  messagingSenderId: "26499305237",
  appId: "1:26499305237:web:2be68195dc3d2db3c7631c",
  measurementId: "G-GZRNXE4EN2"
};
export default firebaseConfig;